import { render, staticRenderFns } from "./main.vue?vue&type=template&id=6c1ef298&scoped=true&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"
import style0 from "./main.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./main.vue?vue&type=style&index=1&id=6c1ef298&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1ef298",
  null
  
)

export default component.exports